import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        classifiers: '=',
        sites: '=',
        view: '=',
        defaultFilter: '=',
        forceShowCsvExport: '='
    },
    template: `
        <div class="{{ vm.outerContainerCssClass }}">
            <div class="heading01 type01" ng-if="vm.view!=='modal'">
                <h1>{{ 'reports.User results' | translate }}</h1>
            </div>
            <div class="block02" ng-class="{ open: vm.filters === true }">
                <div class="heading01 theme01">
                    <h3 ng-click="vm.changeFilter()">{{ 'filter.Filters' | translate }}</h3>
                </div>
                <!-- ngIf: vm.filters===true -->
                <div class="table-filters" ng-if="vm.filters === true">
                    <reports-users-filter
                        view="vm.view"
                        list="vm.list"
                        filter="vm.filter"
                        default-filter="vm.defaultFilter"
                        classifiers="vm.classifiers"
                        filter-overview="vm.filterOverview"
                        sites="vm.sites"
                    />
                </div>
            </div>

            <div class="{{ vm.innerContainerCssClass }}">
                <div class="heading01">
                    <h2 ng-if="vm.view!=='modal'">{{ 'reports.Report' | translate }}</h2>
                    <ul class="actions01" ng-if="vm.view!=='modal' || vm.forceShowCsvExport">
                        <li><a ng-click="vm.exportCsv()" class="btn ico-download">{{ 'reports.Export as csv' | translate }}</a></li>
                    </ul>
                </div>
                <reports-filter-overview filter-overview="vm.filterOverview"></reports-filter-overview>
                <pagination-tools list="vm.list"></pagination-tools>
                <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
                <div class="" ng-if="!vm.list.loading && vm.list.items.length">
                    <table class="data01" datatable="ng" dt-options="vm.DATATABLES">
                        <thead>
                            <tr>
                                <th>{{ 'reports.Employee name' | translate }}</th>
                                <th>{{ 'reports.Sites' | translate }}</th>
                                <th>{{ 'reports.Course' | translate }}</th>
                                <th ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()">{{ 'reports.Participation' | translate }}</th>
                                <th>{{ 'reports.Version' | translate }}</th>
                                <th>{{ 'reports.Completion date' | translate }}</th>
                                <th>{{ 'reports.Expire date' | translate }}</th>
                                <th>{{ 'reports.Duration' | translate }}</th>
                                <th>{{ 'reports.Status' | translate }}</th>
                                <th></th>
                                <th class="none dt-hide"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr ng-repeat="item in vm.list.items">
                                <td>{{ item.name }}</td>
                                <td>{{ item.sites }}</td>
                                <td>
                                    <a ng-if="!item.externalParticipationId" ui-sref="authorized.courses.courses.edit.occurrence.edit.general({id: item.courseId, occurrenceId: item.occurrenceId})">
                                        {{ item.course }}
                                    </a>
                                    <a ng-if="item.externalParticipationId" ui-sref="authorized.courses.participations.detail({ id: item.externalParticipationId })">
                                        {{ item.course }}
                                    </a>
                                    <span ng-if="item.files && item.files.length > 0" class="badge round ico-document" uib-tooltip={{vm.tooltipFileText}} tooltip-append-to-body="true" ></span>
                                </td>
                                <td ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()">{{ item.type }}</td>
                                <td>{{ item.version }}</td>
                               <td>
                                    {{ (item.status === vm.COURSE_STATUS_TYPE_ENUM.KEYS.PASSED || item.status === vm.COURSE_STATUS_TYPE_ENUM.KEYS.NOT_PASSED) ?
                                        vm.MomentService.formatDate(item.date) : '' }}
                                </td>
                                <td ng-if="item.expireDate">{{ vm.MomentService.formatDate(item.expireDate) }}</td>
                                <td ng-if="!item.expireDate && item.isPassed">{{ 'reports.Does not expire' | translate }}</td>
                                <td ng-if="!item.expireDate && !item.isPassed">{{ 'reports.Has not passed' | translate }}</td>
                                <td>
                                    <span ng-if="item.durationFormatted" >{{ item.durationFormatted }}</span>
                                    <span ng-if="!item.durationFormatted"> 00:00:00 </span>
                                </td>
                                <td>
                                    <span ng-if="!item.externalParticipationId">{{ vm.COURSE_STATUS_TYPE_ENUM.LABELS[item.status] }}</span>
                                    <span ng-if="item.externalParticipationId">
                                        {{ vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.LABELS[item.status] }}
                                    </span>
                                </td>
                                <td class="actions">
                                    <a ng-if="item.certificateId"
                                       ng-click="vm.downloadCertificate(item.certificateId, item.occurrenceId)"
                                       class="btn ico-download icononly"
                                       uib-tooltip="{{ 'reports.Download certificate' | translate }}"
                                     ></a>
                                </td>
                                <td ng-if="!item.externalParticipationId">
                                    <h3>{{ 'reports.Trainings' | translate }}</h3>
                                    <div class="form">
                                        <div class="row">
                                            <span class="label">{{ 'reports.Order of trainings' | translate }}</span>
                                            <div class="items">
                                                <span class="text">{{ vm.COURSE_TRAINING_ORDER_TYPE_ENUM.LABELS[item.trainingOrderType] }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <list-empty list="item.trainings" show-add-message="false"></list-empty>
                                    <table class="data01 mt1em" ng-if="item.trainings.length">
                                        <thead>
                                            <tr>
                                                <th>{{ 'reports.Training name' | translate }}</th>
                                                <th>{{ 'reports.Type' | translate }}</th>
                                                <th>{{ 'reports.Date' | translate }}</th>
                                                <th>{{ 'reports.Expected duration (h)' | translate }}</th>
                                                <th>{{ 'reports.Duration' | translate }}</th>
                                                <th>{{ 'reports.Result' | translate }}</th>
                                                <th>{{ 'reports.Status' | translate }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr ng-repeat="training in item.trainings">
                                                <td>{{ training.name }}</td>
                                                <td>{{ vm.COURSE_TRAINING_TYPE_ENUM.LABELS[training.type] }}</td>
                                                <td>{{ vm.MomentService.formatDate(training.date) }}</td>
                                                <td ng-if="training.expectedDurationFormatted">{{ training.expectedDurationFormatted }}</td><td ng-if="!training.expectedDurationFormatted">-</td>
                                                <td ng-if="training.spentDurationFormatted">{{ training.spentDurationFormatted }}</td> <td ng-if="!training.spentDurationFormatted">00:00:00</td>
                                                <td ng-if="training.type !== vm.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE
                                                    && training.type !== vm.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST">
                                                    {{ training.result }} </td>
                                                <td ng-if="training.type == vm.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST">
                                                    <a ng-if="training.status == vm.COURSE_TRAINING_STATUS_TYPE_ENUM.KEYS.PASSED
                                                        || training.status == vm.COURSE_TRAINING_STATUS_TYPE_ENUM.KEYS.NOT_PASSED
                                                        || training.status == vm.COURSE_TRAINING_STATUS_TYPE_ENUM.KEYS.NOT_PASSED_CAN_RETAKE"
                                                        ui-sref="authorized.forms.validations.detail({ id: training.occurrenceTrainingProgressId })">
                                                        {{ training.result }}
                                                    </a>
                                                </td>
                                                <td ng-if="training.type == vm.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE
                                                    && training.materialType !== vm.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.COURSY_CONTENT">
                                                    <div ng-if="training.progressPc">{{ 'reports.Progress' | translate }}: {{ training.progressPc }}%</div>
                                                    <div ng-if="training.chaptersTotal">{{ 'reports.Lessons' | translate }}: {{ training.chaptersPassed }}/{{ training.chaptersTotal }}</div>
                                                    <div ng-if="training.testsTotal">{{ 'reports.Tests' | translate }}: {{ training.testsPassed }}/{{ training.testsTotal }}</div>
                                                </td>
                                                <td ng-if="training.type == vm.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE
                                                    && training.materialType == vm.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.COURSY_CONTENT">
                                                    {{ 'course.materialSource.Chapters' | translate }}: {{ training.chaptersPassed }}/{{ training.chaptersTotal }}<br>
                                                </td>
                                                <td>
                                                    <span>
                                                        {{ vm.COURSE_TRAINING_STATUS_TYPE_ENUM.LABELS[training.status] }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td ng-if="item.externalParticipationId">
                                    <p>{{ 'reports.External participation - No training list' | translate }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination list="vm.list"></pagination>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($window, $translate, lodash, moment, DATATABLES,
                 ListFactory, CourseResource, AuthResource, ModalService,
                 TokenService, MomentService, PrivilegeService, SiteService, ReportService,
                 COURSE_TRAINING_ORDER_TYPE_ENUM, COURSE_TRAINING_TYPE_ENUM,
                 COURSE_STATUS_TYPE_ENUM, COURSE_TRAINING_STATUS_TYPE_ENUM,
                 USER_STATUS_ENUM, COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM,
                 COURSE_TARGET_NEED_TYPE_ENUM, USER_ACTIVATION_STATUS_ENUM,
                 COURSE_DURATION_TYPE_ENUM, COURSE_TRAINING_MATERIAL_TYPE_ENUM) {
        this.$window = $window;
        this.$translate = $translate;
        this.lodash = lodash;
        this.moment = moment;
        this.DATATABLES = DATATABLES;
        this.AuthResource = AuthResource;
        this.TokenService = TokenService;
        this.MomentService = MomentService;
        this.PrivilegeService = PrivilegeService;
        this.SiteService = SiteService;
        this.ReportService = ReportService;
        this.ModalService = ModalService;
        this.COURSE_TRAINING_ORDER_TYPE_ENUM = COURSE_TRAINING_ORDER_TYPE_ENUM;
        this.COURSE_TRAINING_MATERIAL_TYPE_ENUM = COURSE_TRAINING_MATERIAL_TYPE_ENUM;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_STATUS_TYPE_ENUM = COURSE_STATUS_TYPE_ENUM;
        this.COURSE_TRAINING_STATUS_TYPE_ENUM = COURSE_TRAINING_STATUS_TYPE_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM = COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
        this.USER_ACTIVATION_STATUS_ENUM = USER_ACTIVATION_STATUS_ENUM;
        this.COURSE_DURATION_TYPE_ENUM = COURSE_DURATION_TYPE_ENUM;
        this.list = ListFactory.createWithPagination(CourseResource.userResultsReport.bind(CourseResource));
        this.tooltipFileText = this.$translate.instant('occurrence.Files added');
    }

    getParticipationDuration (item) {
        if (!item.duration) {
            return null;
        }
        return `${item.duration}${this.COURSE_DURATION_TYPE_ENUM.SHORTEN[item.durationType ? item.durationType : 'HOURS']}`;
    }

    changeFilter () {
        this.filters = !this.filters;
        this.$window.localStorage.setItem('is_user_results_report_filter_opened', this.filters);
    }

    $onInit () {
        this.outerContainerCssClass = 'col00';
        this.innerContainerCssClass = 'well';
        if (this.view === 'modal') {
            this.outerContainerCssClass = '';
            this.innerContainerCssClass = '';
        }

        // this means all sites are accessible and no point in choosing them
        this.filterOverview = { };
        if (this.lodash.isEmpty(this.defaultFilter)) {
            this.defaultFilter = {
                siteIds: this.sites.map(site => site.id),
                statuses: [this.COURSE_STATUS_TYPE_ENUM.KEYS.PASSED],
                participationTypes: [
                    this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.COMPULSORY,
                    this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.OPTIONAL
                ],
                employeeStatuses: [this.USER_STATUS_ENUM.KEYS.ACTIVE, this.USER_STATUS_ENUM.KEYS.NOT_STARTED],
                employeeAccounts: [this.USER_ACTIVATION_STATUS_ENUM.KEYS.ACTIVATED],
                contentTypes: { course: 1, guidance: 0 },
                to: this.moment().format('YYYY-MM-DD'),
                from: this.moment().subtract(3, 'month').format('YYYY-MM-DD')
            };
        }

        this.exportSelectedColumns = [];
        this.filters = JSON.parse(this.$window.localStorage.getItem('is_user_results_report_filter_opened'));
        this.filter = angular.copy(this.defaultFilter);
        this.list.fetch({}, this.filter);
    }

    exportCsv () {
        const filter = {
            'siteIds[]': this.filter.siteIds,
            'statuses[]': this.filter.statuses,
            'participationTypes[]': this.filter.participationTypes,
            'employeeStatuses[]': this.filter.employeeStatuses,
            'employeeAccounts[]': this.filter.employeeAccounts,
            'departmentIds[]': this.filter.departmentIds,
            'roleIds[]': this.filter.roleIds,
            'levelIds[]': this.filter.levelIds,
            course: this.filter.course,
            userId: this.filter.userId,
            workingTo: this.filter.workingTo,
            workingFrom: this.filter.workingFrom,
            to: this.filter.to,
            from: this.filter.from,
            expireTo: this.filter.expireTo,
            expireFrom: this.filter.expireFrom,
            onlyWithoutExpireDate: this.filter.onlyWithoutExpireDate,
            onlyCourseNotPassed: this.filter.onlyCourseNotPassed
        };

        const selectedColumns = this.exportSelectedColumns;

        return this.ModalService.open({
            animation: true,
            template: `
                <modals-report-employeeresults-export
                    cancel="vm.$uibModalInstance.dismiss()"
                    class="wrapper"
                    filter="vm.filter"
                    selected-columns="vm.selectedColumns"
                    />
                `,
            size: 'medium',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.filter = filter;
                this.selectedColumns = selectedColumns;
            }
        });
    }

    downloadCertificate (certificateId, occurrenceId) {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const url = `${SEED_CORE.ENV.API_URL}user/user/export-certificate/${certificateId}/${occurrenceId}?tacToken=${token}`;
                this.$window.open(url);
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/reports/users/index.js